import React, { Component } from 'react'
import { KeypadOption, TagButtonStyle, TeamDropDown, Title, ToggleArea } from '../styles/dialpadstyle'
import PropTypes from 'prop-types';
import Select from 'react-select-plus';
import {
  FormWrapper,
  FormColumn,
  FormGroup,
  ControlLabel,
  FormControl,
  Button
} from 'modules/theme';
import Toggle from 'react-toggle';
import moment from 'moment';
import Datetime from 'react-datetime';

export class CallTagTheme extends Component {

  constructor(props) {
    super(props);
    this.state = {
      dnc: false,
      callback: false,
      startDate: '',
      endDate: '',
      global: ''
    }
  }

  renderFormGroup(label, props) {
    return (
      <FormGroup>
        {/* <ControlLabel required={props.required}>{label}</ControlLabel> */}
        <FormControl {...props} />
      </FormGroup>
    );
  }

  renderStartDate() {
    const { __ } = this.context;
    const { startDate } = this.state;
    const props = {
      inputProps: { placeholder: __('Select Start date') },
      timeFormat: 'HH:mm',
      dateFormat: 'YYYY/MM/DD',
      closeOnSelect: true
    };
    let zone = {};
    var timeZone = moment.tz.guess();
    zone.value = timeZone;
    zone.label = zone.value;
    return (
      <div>
        <Datetime
          {...props}
          value={startDate}
          // onChange={date => this.onDateChange('startDate', date)}
          onChange={date => {
            this.setState({
              startDate:
                parseInt(
                  moment(date)
                    .tz(zone.value)
                    .format('X')
                ) * 1000
            });
            // this.setState({ 'startDate': startDate });
          }}
        />
      </div>
    )
  }
  renderEndDate() {
    const { __ } = this.context;
    const { endDate } = this.state;
    const props = {
      inputProps: { placeholder: __('Select End date') },
      timeFormat: 'HH:mm',
      dateFormat: 'YYYY/MM/DD',
      closeOnSelect: true
    };
    let zone = {};
    var timeZone = moment.tz.guess();
    zone.value = timeZone;
    zone.label = zone.value;
    return (
      <div>
        <Datetime
          {...props}
          value={endDate}
          // onChange={date => this.onDateChange('startDate', date)}
          onChange={date => {
            this.setState({
              endDate:
                parseInt(
                  moment(date)
                    .tz(zone.value)
                    .format('X')
                ) * 1000
            });
            // this.setState({ 'endDate': endDate });
          }}
        />
      </div>
    )
  }

  render() {
    const {
      title,
      onChangeSelect,
      tagValue,
      optionsTag,
      onCommentChange,
      ButtonText,
      isBack = true,
      onDoneClick } = this.props
    return (
      <span style={{ width: '100%' }}>

        <TagButtonStyle>
          <FormWrapper style={{display:"none"}}>
            <FormColumn style={{ paddingRight: '0px' }}>
              <ToggleArea>
                <Toggle
                  defaultChecked={this.state.dnc}
                  icons={{
                    checked: <span>Yes</span>,
                    unchecked: <span>No</span>
                  }}
                  onChange={this.onChange}
                  name="dnc"
                  id="dnc"
                  value={this.state.dnc}
                />
                <ControlLabel>DNC</ControlLabel>
              </ToggleArea>
            </FormColumn>
            <FormColumn>
              <ToggleArea>
                <Toggle
                  defaultChecked={this.state.callback}
                  icons={{
                    checked: <span>Yes</span>,
                    unchecked: <span>No</span>
                  }}
                  onChange={this.onChange}
                  name="callback"
                  id="callback"
                  value={this.state.callback}
                />
                <ControlLabel>CallBack</ControlLabel>
              </ToggleArea>
            </FormColumn>
          </FormWrapper>
          <Title>
            {title}
          </Title>
          <form>
            <TeamDropDown>
              <Select
                placeholder="Select Your Review"
                onChange={onChangeSelect}
                value={tagValue}
                options={optionsTag}
              />
            </TeamDropDown>
            <KeypadOption>
              <span style={{display: 'none'}}>
                <FormWrapper>
                  <FormColumn style={{ paddingRight: '5px' }}>{this.renderStartDate()}</FormColumn>
                  <FormColumn>{this.renderEndDate()}</FormColumn>
                </FormWrapper>
                <FormWrapper style={{ marginBottom: '10px' }}>
                  <FormColumn style={{ paddingRight: '0px', textAlign: 'center' }}>
                    <FormControl defaultChecked={true} name="radio" componentClass="radio" value={this.state.global} >
                      {('GLobal')}
                    </FormControl>
                  </FormColumn>
                  <FormColumn style={{ textAlign: 'center' }}>
                    <FormControl defaultChecked={false} name="radio" componentClass="radio" value={this.state.team}>
                      {('Team')}
                    </FormControl>
                  </FormColumn>
                </FormWrapper>
              </span>
              <FormWrapper>
                {/* <FormColumn></FormColumn> */}
                <FormColumn>
                  {this.renderFormGroup('', {
                    defaultValue: '',
                    placeholder: 'Type your comment...',
                    autoFocus: false,
                    required: true,
                    id: 'comment',
                    value: this.props.comment,
                    onChange: onCommentChange
                  })}
                </FormColumn>
              </FormWrapper>
            </KeypadOption>
            {/* <Button btnStyle="simple" size="small" onClick={OnClickEvent} block>
            {ButtonText}
          </Button> */}
            {!isBack &&
              <Button
                onClick={onDoneClick}
                btnStyle={"default"}
                block
                size="xl"
              >
                {ButtonText}
              </Button>
            }
          </form>
        </TagButtonStyle>
      </span>
    )
  }
}

CallTagTheme.propTypes = {
  isConnected: PropTypes.bool.isRequired
};

CallTagTheme.contextTypes = {
  __: PropTypes.func
};

export default CallTagTheme


// WEBPACK FOOTER //
// ./src/modules/theme/theme1/common/components/CallTagTheme.js